import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { Header } from "../../../components/header";
import { CardHeader } from "../../../components/cards";
import { SendIcon } from "../../../components/icons";
import { StockUnitForm } from "../components";

interface IReceptionForm {
  productId?: number;
  warehouseId?: number;
  batchNumber?: string;
  quantity?: number;
  enteredAt?: string;
}

export const CreateStockUnit: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const productId = searchParams.get("productId");

  const form = useForm<IReceptionForm>({
    mode: "all",
    defaultValues: {
      productId: productId ? +productId : undefined,
      enteredAt: new Date().toISOString().slice(0, 10),
    },
  });

  useEffect(() => {
    if (productId) {
      form.setValue("productId", +productId);
    }
  }, [productId]);

  const submit = () => {
    const values = form.getValues();
    if (
      !values.productId ||
      !values.warehouseId ||
      !values.batchNumber ||
      !values.quantity ||
      !values.enteredAt
    ) {
      form.trigger();
      return;
    }

    const params = new URLSearchParams({
      productId: String(values.productId),
      warehouseId: String(values.warehouseId),
      batchNumber: values.batchNumber,
      quantity: String(values.quantity),
      enteredAt: values.enteredAt,
    });
    navigate(`/stock-unit/scan?${params.toString()}`);
  };

  return (
    <>
      <Header
        title="Réception de stock"
        subtitle="Étape 1 : renseigner le lot avant de scanner"
        buttons={[
          {
            actionText: "Annuler",
            bgColor: "indigo",
            textColor: "white",
            link: `/stock-units`,
            icon: <SendIcon />,
          },
        ]}
      />
      <div className="main-container">
        <div className="card">
          <CardHeader title="Nouvelle réception" />
          <StockUnitForm loading={false} submit={submit} form={form} />
        </div>
      </div>
    </>
  );
};
